import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/ic-search-outline-white.svg")